module.exports = __webpack_public_path__ + "img/antes_despues_300.605a4944.png";